export function isSigninRolloutActive(): boolean {
  return process.env.AUTH_SIGNIN_ROLLOUT_ACTIVE === 'true'
}
